module.exports = __webpack_public_path__ + "static/withoutaspectorpers-f4def9457bc4b718c6ff6d4c2354b952.png";